import { render } from "./TransactionComponent.vue?vue&type=template&id=0b1c320a&scoped=true"
import script from "./TransactionComponent.vue?vue&type=script&lang=js"
export * from "./TransactionComponent.vue?vue&type=script&lang=js"

import "./TransactionComponent.vue?vue&type=style&index=0&id=0b1c320a&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1c320a"]])

export default __exports__